<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :toolbar="toolbar"
      :selection="true"
      label-width="100px"
    />
  </div>
</template>

<script>
// import x from ''
import fieldFilter from '@/utils/fieldFilter.js'
export default {
  name: 'Youhuifangan',
  components: {},
  data() {
    return {
      url: '/business/discountterm/page',
      columns: [
        {
          label: '方案名称',
          prop: 'projectName'
        },
        // {
        //   label: '承担方',
        //   prop: 'operationName'
        // },
        {
          label: '活动状态',
          prop: 'state',
          template: function(index, reocrd) {
            if (reocrd.state === '1') {
              return '未开始'
            }
            else if (reocrd.state === '2') {
              return '进行中'
            }
            else if (reocrd.state === '3') {
              return '已结束(手动)'
            }
            else {
              return '已结束(到期)'
            }
          }
        },
        {
          label: '活动开始时间',
          prop: 'discountStartDay'

        },
        {
          label: '活动结束时间',
          prop: 'discountEndDay'
        }
      ],
      // 操作栏
      handles: {
        width: 150,
        btns: [
          {
            label: '详情',
            permission: 'station.activity.discount.details',
            icon: 'el-icon-view',
            handle: resp => {
              this.$router.push({ path: './discountDetail', query: { disabled: true, data: resp.id }})
            }
          },
          {
            label: '终止',
            permission: 'station.activity.discount.delete',
            style: 'color:red',
            getLabelDisabled: record => {
              return !!(Number(record.state) === 3 || Number(record.state) === 4)
            },
            getLabelStyle: record => {
              return Number(record.state) === 3 || Number(record.state) === 4 ? 'color: #c0c4cc;' : 'color:red'
            },
            isConfirm: true,
            confirmText: '终止的电站活动无法恢复，确定执行此操作？',
            url: '/business/discountterm/termination',
            method: 'get',
            before: (index, record) => {
              return {
                id: record.id
              }
            },
            handle: resp => {
              this.$refs.tableref.queryTable()
            }
          }
        ]
      },
      query: [
        {
          label: '方案名称',
          prop: 'projectName',
          placeholder: '请输入方案名称'
        },
        // {
        //   label: '承担方',
        //   prop: 'operatorId',
        //   type: 'select3',
        //   placeholder: '请选择承担方',
        //   data: [],
        //   remoteMethod: (val) => {
        //     this.getTrafficOrg(val)
        //   }
        //   // data: [{
        //   //     value: "0",
        //   //     label: "全平台直连",
        //   // },{
        //   //     value: "1",
        //   //     label: "加盟直连",
        //   // },{
        //   //     value: "2",
        //   //     label: "互联互通",
        //   // }]
        // },
        {
          label: '活动状态',
          prop: 'state',
          type: 'select',
          placeholder: '请选择活动状态',
          data: [{
            value: '1',
            label: '未开始'
          }, {
            value: '2',
            label: '进行中'
          }, {
            value: '3',
            label: '已结束(手动)'
          }, {
            value: '4',
            label: '已结束(到期)'
          }]
        },
        {
          label: '开始时间',
          prop: 'discountStartDay',
          type: 'date2'
        },
        {
          label: '结束时间',
          prop: 'discountEndDay',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'station.activity.discount.add',
          type: 'primary',
          handle: resp => {
            // this.$router.push('./addDiscount')
            this.$router.push({
              path: './addDiscount',
              query: {
                disabled: false
              }
            })
          }
        }
      ]
    }
  },
  methods: {
    getTrafficOrg(val) {
      const data = {
        attr: 3,
        orgName: val
      }
      this.$store.dispatch('form/handle', {
        url: '/business/discountterm/getResponsibleOrgTree',
        data: data,
        method: 'get',
        callback: resp => {
          if (resp) {
            this.query[1].data = resp
            // for(var i=0;i<resp.length;i++){
            //   this.query[1].data[i].label = resp.name
            //   this.query[1].data[i].value = resp.id
            // }
            // this.query[1].data.label = resp.name
            // this.query[1].data.value = resp.id
          }
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/discount/discount.vue